import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { GitlabAiAccesses } from "./accesses.ts";
import { GitlabAiComponents } from "./components.ts";
import { GitlabIconUrl } from "./icon.ts";

const GitlabAiFilters = {
  group: { keys: ["name"] },
  // Matches the raw "<project path>:<role>" tokens. Rule filter values
  // compile to regular expressions, so rules can scope by project
  // ("acme/app:.*"), by role (".*:reporter"), or exactly
  // ("acme/app:developer").
  policy: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type GitlabAiFilters = typeof GitlabAiFilters;

export const GitlabAiRegistration = Registration({
  accesses: GitlabAiAccesses,
  category: "resource",
  components: GitlabAiComponents,
  docs: {
    install: "agentic-gateway/mcp-server/gitlab",
    request: "agentic-gateway/requesting-access",
  },
  filters: GitlabAiFilters,
  itemKind: "Group",
  label: "GitLab",
  logoUrl: GitlabIconUrl,
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "credential" }],
});

registerIntegration("gitlab-ai", GitlabAiRegistration);
